<script setup>
import { ref, onBeforeUnmount, onBeforeMount } from "vue";
import { useStore } from "vuex";

import Navbar from "@/examples/PageLayout/Navbar.vue";
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import api from "@/services/apiService";

const email = ref("");
const successMessage = ref("");
const errorMessage = ref("");

const store = useStore();
const body = document.getElementsByTagName("body")[0];

onBeforeMount(() => {
  store.state.hideConfigButton = true;
  store.state.showNavbar = false;
  store.state.showSidenav = false;
  store.state.showFooter = false;
  body.classList.remove("bg-gray-100");
});

onBeforeUnmount(() => {
  store.state.hideConfigButton = false;
  store.state.showNavbar = true;
  store.state.showSidenav = true;
  store.state.showFooter = true;
  body.classList.add("bg-gray-100");
});

const handleSubmit = async () => {
  try {
    const response = await api.post("/forgot-password", { email: email.value });

    // Check if response and response.data exist
    if (response && response.data && response.data.message) {
      successMessage.value = response.data.message;
      errorMessage.value = "";
    } else {
      // Fallback if structure is unexpected
      successMessage.value = "Enlace enviado correctamente.";
     
    }

  } catch (error) {
    console.error("Error response:", error);
    errorMessage.value =
      error.response?.data?.message || "Hubo un error. Inténtalo de nuevo.";
    successMessage.value = "";
  }
};


</script>

<template>
  <div class="container top-0 position-sticky z-index-sticky">
    <div class="row">
      <div class="col-12">
        <navbar isBlur="blur  border-radius-lg my-3 py-2 start-0 end-0 mx-4 shadow" v-bind:darkMode="true" isBtn="bg-gradient-primary" />
      </div>
    </div>
  </div>

  <main class="mt-0 main-content">
    <section>
      <div class="page-header min-vh-100">
        <div class="container">
          <div class="row">
            <div class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0">
              <div class="card card-plain">
                <div class="pb-0 card-header text-start">
                  <h4 class="font-weight-bolder">¿Olvidaste tu contraseña?</h4>
                  <p class="mb-0">Ingresa tu correo y te enviaremos un enlace para restablecerla.</p>
                </div>
                <div class="card-body">
                  <form @submit.prevent="handleSubmit">
                    <div class="mb-3">
                      <argon-input
                        id="email"
                        type="email"
                        placeholder="Correo Electrónico"
                        name="email"
                        size="lg"
                        v-model="email"
                      />
                    </div>

                    <!-- Only show error if no success message -->
                    <p v-if="errorMessage && !successMessage" class="text-danger">{{ errorMessage }}</p>
                    <p v-if="successMessage" class="text-success">{{ successMessage }}</p>

                    <div class="text-center">
                      <argon-button class="mt-4" variant="gradient" color="primary" fullWidth size="lg" type="submit">
                        Enviar enlace
                      </argon-button>
                    </div>
                  </form>
                </div>
                <div class="px-1 pt-0 text-center card-footer px-lg-2">
                  <p class="mx-auto mb-4 text-sm">
                    ¿Recordaste tu contraseña?
                    <router-link to="/signin" class="text-primary text-gradient font-weight-bold">
                      Iniciar sesión
                    </router-link>
                  </p>
                </div>
              </div>
            </div>

            <div class="top-0 my-auto text-center col-6 d-lg-flex d-none h-100 pe-0 position-absolute end-0 justify-content-center flex-column">
              <div
                class="position-relative bg-gradient-primary h-100 m-3 px-7 border-radius-lg d-flex flex-column justify-content-center overflow-hidden"
                :style="{ backgroundImage: `url(${require('@/assets/img/house1.jpeg')})`, backgroundSize: 'cover' }"
              >
                <span class="mask bg-gradient-primary opacity-6"></span>
                <h4 class="mt-5 text-white font-weight-bolder position-relative">
                  "Gestión de Alquiler y Venta de Propiedades con ARB"
                </h4>
                <p class="text-white position-relative">
                  Simplifica la administración de alquileres y ventas de inmuebles con ARB.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>
